export default {
  audienceSummary: JSON.parse(localStorage.getItem('audience')) || {},
  selectTypes: [],
  hasAudience: null,
  statusAudience: null,
  recipient: null,
  schemaAudience: null,
  overview: null,
  audienceFeed: null,

  // New Audience
  importContacts: {
    currentStep: 1,
    validSteps: [],
    completedSteps: [],
    importedData: undefined,
    importSuccess: false
  },
}
